(function () {
  'use strict';

  /* ----------------------------------------------------------
     GHOST ORDINALS — large faded numbers on collection titles
     ---------------------------------------------------------- */

  function initSectionOrdinals() {
    var titles = document.querySelectorAll(
      '.collection .collection__title, .featured-collection .title-wrapper'
    );

    titles.forEach(function (el, i) {
      var num = document.createElement('span');
      num.className = 'jn-section-num';
      num.setAttribute('aria-hidden', 'true');
      num.textContent = String(i + 1).padStart(2, '0');

      var parent = el.parentElement;
      if (parent) {
        var pos = window.getComputedStyle(parent).position;
        if (pos === 'static') {
          parent.style.position = 'relative';
        }
        parent.appendChild(num);
      }
    });
  }

  /* ----------------------------------------------------------
     DUAL CURSOR — precision dot + lagging ring
     Only on pointer:fine (desktop mouse) devices
     ---------------------------------------------------------- */

  function initCursor() {
    if (!window.matchMedia('(pointer: fine)').matches) return;

    var dot = document.createElement('div');
    dot.className = 'jn-cursor-dot';

    var ring = document.createElement('div');
    ring.className = 'jn-cursor-ring';

    document.body.appendChild(dot);
    document.body.appendChild(ring);

    var dotX = 0, dotY = 0;
    var ringX = 0, ringY = 0;
    var mouseX = 0, mouseY = 0;
    var raf = null;

    document.addEventListener('mousemove', function (e) {
      mouseX = e.clientX;
      mouseY = e.clientY;

      dotX = mouseX;
      dotY = mouseY;
      dot.style.left = dotX + 'px';
      dot.style.top  = dotY + 'px';

      document.body.classList.add('jn-cursor-active');
    });

    document.addEventListener('mouseleave', function () {
      document.body.classList.remove('jn-cursor-active');
    });

    function lerp(a, b, t) { return a + (b - a) * t; }

    function tick() {
      ringX = lerp(ringX, mouseX, 0.12);
      ringY = lerp(ringY, mouseY, 0.12);
      ring.style.left = ringX + 'px';
      ring.style.top  = ringY + 'px';
      raf = requestAnimationFrame(tick);
    }

    raf = requestAnimationFrame(tick);

    /* Ring expands on card hover */
    document.addEventListener('mouseover', function (e) {
      var card = e.target.closest('.card-wrapper');
      document.body.classList.toggle('jn-cursor-on-card', !!card);
    });
  }

  /* ----------------------------------------------------------
     TICKER STRIP — editorial marquee between hero and products
     Injected after the hero banner section
     ---------------------------------------------------------- */

  var TICKER_PHRASES = [
    'New arrivals',
    'Considered design',
    'London',
    'Crafted for everyday life',
    'Josh & Nicol',
    'Minimal · Premium · Wearable',
    'New arrivals',
    'Considered design',
    'London',
    'Crafted for everyday life',
    'Josh & Nicol',
    'Minimal · Premium · Wearable'
  ];

  function initTicker() {
    var banner = document.querySelector('.banner');
    if (!banner) return;

    var section = banner.closest('.shopify-section') || banner.parentElement;
    if (!section) return;

    var ticker = document.createElement('div');
    ticker.className = 'jn-ticker';

    var track = document.createElement('div');
    track.className = 'jn-ticker__track';

    /* Double the phrases so the seamless loop works */
    var allPhrases = TICKER_PHRASES.concat(TICKER_PHRASES);
    allPhrases.forEach(function (phrase) {
      var item = document.createElement('span');
      item.className = 'jn-ticker__item';
      item.textContent = phrase;
      track.appendChild(item);
    });

    ticker.appendChild(track);
    section.insertAdjacentElement('afterend', ticker);
  }

  /* ----------------------------------------------------------
     MARQUEE — announcement bar slow scroll
     ---------------------------------------------------------- */

  function initMarquee() {
    var bars = document.querySelectorAll('.announcement-bar__message');
    bars.forEach(function (bar) {
      var originalText = bar.textContent.trim();
      if (!originalText) return;

      /* Double content for seamless loop */
      var doubled = originalText + ' — ' + originalText + ' — ';
      var track = document.createElement('span');
      track.className = 'jn-marquee-track';
      track.textContent = doubled;

      bar.textContent = '';
      bar.appendChild(track);
      bar.classList.add('jn-marquee-init');
    });
  }

  /* ----------------------------------------------------------
     SCROLL PROGRESS LINE
     ---------------------------------------------------------- */

  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.className = 'jn-scroll-progress';
    document.body.appendChild(bar);

    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var scrollTop  = window.scrollY || document.documentElement.scrollTop;
        var docHeight  = document.documentElement.scrollHeight - window.innerHeight;
        var progress   = docHeight > 0 ? scrollTop / docHeight : 0;
        bar.style.transform = 'scaleX(' + Math.min(progress, 1) + ')';
        ticking = false;
      });
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     HERO PARALLAX — subtle vertical parallax on .banner__media
     Only if prefers-reduced-motion is not set
     ---------------------------------------------------------- */

  function initHeroParallax() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var media = document.querySelector('.banner__media');
    if (!media) return;

    var ticking = false;

    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var scrollY = window.scrollY || 0;
        media.style.transform = 'translateY(' + (scrollY * 0.25) + 'px)';
        ticking = false;
      });
    }, { passive: true });
  }

  /* ----------------------------------------------------------
     BOOT
     ---------------------------------------------------------- */

  function boot() {
    initSectionOrdinals();
    initCursor();
    initTicker();
    initMarquee();
    initScrollProgress();
    initHeroParallax();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
